import _ from "lodash";
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import { v4 as uuidv4 } from "uuid";

export const cloneItem = (
    itemsInOrder,
    orderItemsPanelSelection,
    SelectedItemName,
    forceNew = false,
    itemIdentifier = null
) => {
    let itemInOrder;
    if (itemsInOrder && itemsInOrder.items && itemsInOrder.items.length > 0)
        itemInOrder = _.find(itemsInOrder.items, {
            item_code: SelectedItemName,
        });

    let finalQuantity = 0;
    if (!itemInOrder) {
        // We will create a new copy object and add the quantity to it.
        // Original object
        if (orderItemsPanelSelection) {
            itemInOrder = { ...orderItemsPanelSelection };
        }
        finalQuantity = 1;
    } else {
        finalQuantity = itemInOrder.qty + 1;
        // itemInOrder.identifier = itemInOrder.identifier;
    }

    itemInOrder = _.cloneDeep(itemInOrder);

    // We will remove this but when we update the model, basically the keyword is qty not pos_qty. !.
    itemInOrder.qty = finalQuantity;
    const date = new Date();
    const formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss.SSSSSSSSS");
    itemInOrder.ordered_time = formattedDate;
    if (forceNew) {
        itemInOrder.identifier = "entry_" + uuidv4();
    } else {
        if (itemIdentifier && itemIdentifier.length > 0) {
            itemInOrder.identifier = itemIdentifier;
        } else {
            // We should not reach here at all, but this is hiding a bug ..!
            itemInOrder.identifier = "entry_" + uuidv4();
        }
    }

    return itemInOrder;
};

export const cloneAddOn = (systemAdOnItem, qty, parentIdentifier, overrideRate = null) => {
    let clonedItem = _.cloneDeep(systemAdOnItem);

    // We will remove this but when we update the model, basically the keyword is qty not pos_qty. !.
    clonedItem.qty = qty;
    const date = new Date();
    const formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss.SSSSSSSSS");

    const rateToUse = overrideRate != null ? overrideRate : systemAdOnItem.standard_rate;
    clonedItem.price_list_rate = rateToUse;
    clonedItem.rate = rateToUse;
    clonedItem.parent_item = parentIdentifier;
    clonedItem.standard_rate = rateToUse;
    clonedItem.ordered_time = formattedDate;
    clonedItem.discount_percentage = 0;
    clonedItem.item_tax_template = "";
    clonedItem.item_tax_rate = "{}";
    clonedItem.status = "Completed";
    clonedItem.has_serial_no = 0;
    clonedItem.serial_no = "";
    clonedItem.has_batch_no = 0;
    clonedItem.batch_no = "";
    clonedItem.notes = "";
    clonedItem.identifier = "entry_addon_" + uuidv4();

    return clonedItem;
};

export const getOrderShortName = (orderName) => {
    if (orderName) {
        return orderName.split("-").slice(-1);
    } else {
        return "";
    }
};

export const parseCustomerAddress = (customer) => {
    let address = customer?.territory;

    if (
        customer &&
        customer.primary_address &&
        customer.primary_address.split("<br>")[0]
    ) {
        address += " - " + customer.primary_address.split("<br>")[0];
    }

    if (
        customer &&
        customer.primary_address &&
        customer.primary_address.split("<br>")[1]
    ) {
        address += " - " + customer.primary_address.split("<br>")[1];
    }

    return address;
};

export const parseAddress = (address) => {
    let parsedAddress = "";
    if (address) {
        if (address.territory) {
            parsedAddress += address.territory;
        }

        if (address.address_line1) {
            parsedAddress += " - " + address.address_line1;
        }

        if (address.address_line2) {
            parsedAddress += " - " + address.address_line2;
        }

        return parsedAddress;
    }
    return "";
};

export const randomId = (length) => {
    let result = "";
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
        counter += 1;
    }
    return result;
};

export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const escapeHTML = (html) => {
    if (!html) {
        return;
    }
    try {
        // First remove HTML tags
        let text = html.replace(/<[^>]+>/g, "");
        // Then decode HTML entities
        const textarea = document.createElement("textarea");
        textarea.innerHTML = text;
        return textarea.value;
    } catch {
        return html;
    }
};

/** Legacy `/pos/:tableName` segment used before POS Profile `takeaway_table` existed */
export const LEGACY_TAKEAWAY_URL_SEGMENT = "takeaway";

/**
 * True when the POS route `:tableName` refers to the takeaway Restaurant Object.
 * Matches POS Profile link field `takeaway_table`, floor-plan takeaway identifiers,
 * and legacy "takeaway".
 *
 * @param {string} tableName - URL param from `/pos/:tableName/...`
 * @param {object|null} posProfile - Current POS Profile (expects `takeaway_table` link)
 * @param {object|null} takeawayTable - Takeaway bucket from floor payload (`message.takeaway`), optional
 */
export const isTakeawayRouteTableName = (
    tableName,
    posProfile,
    takeawayTable
) => {
    if (!tableName) return false;
    if (tableName === LEGACY_TAKEAWAY_URL_SEGMENT) return true;
    const linked = posProfile?.takeaway_table;
    if (linked && tableName === linked) return true;
    if (takeawayTable) {
        if (takeawayTable.name && tableName === takeawayTable.name) return true;
        if (
            takeawayTable.tableDescription &&
            tableName === takeawayTable.tableDescription
        ) {
            return true;
        }
    }
    return false;
};

/**
 * Preferred `/pos/:segment` path segment for takeaway routes (navigation targets).
 * Uses floor takeaway description when loaded, then POS Profile linked table name, then legacy.
 */
export const getTakeawayUrlSegment = (posProfile, takeawayTable) => {
    return (
        takeawayTable?.tableDescription ||
        posProfile?.takeaway_table ||
        LEGACY_TAKEAWAY_URL_SEGMENT
    );
};

export const defaultErrorToast = (err) => {
    try {
        enqueueSnackbar(
            escapeHTML(
                JSON.parse(JSON.parse(err.response.data._server_messages)[0])
                    .message
            ),
            {
                position: "bottom-right",
                autoClose: true,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: false,
                variant: "error",
            }
        );
    } catch {
        enqueueSnackbar("An error occurred", {
            variant: "error",
        });
    }
};
